const Menu = [
    {
       title: 'Dashboard',
       icon: 'fas fa-chart-pie',
       route: '/dashboard'
    },
    {
       title: 'Campanhas',
       icon: 'fas fa-phone-volume',
       route: '/campaigns'
    },
    {
       title: 'Atendimento a Clientes',
       icon: 'fas fa-funnel-dollar',
       route: '/prospection'
    },
   //  {
   //     title: 'Propostas',
   //     icon: 'fas fa-project-diagram',
   //     route: '/workflow'
   //  },
   //  {
   //     title: 'Contratos',
   //     icon: 'fas fa-file-signature',
   //     route: '/contracts'
   //  },
    {
       title: 'Contratos Pagos',
       icon: 'fas fa-file-invoice-dollar',
       route: '/paidContracts'
    },
    {
      title: 'Produção por Status',
      icon: 'fas fa-cart-arrow-down',
      route: '/production'
   },
   {
      title: 'Produção por Campanha',
      icon: 'fas fa-money-check-alt',
      route: '/campaignLeads'
   },
    {
       title: 'Comissões',
       icon: 'fas fa-hand-holding-usd',
       route: '/commissions'
    },
    {
       title: 'Clientes',
       icon: 'fas fa-users',
       route: '/clients'
    },
	{
		title: 'Solicitações',
		icon: 'fas fa-envelope-open-text',
		items: [
			{
				title: 'Validar Clientes (App)',
				icon: 'fas fa-address-card',
				route: '/pendingAppUsers'
			},
			{
			   title: 'Validar Afiliados',
			   icon: 'fas fa-users-cog',
			   route: '/pendingAffiliates'
			},
			{
				title: 'Solicitações',
				icon: 'fas fa-envelope-open-text',
				route: '/requests'
			},
		]
	},
    {
       title: 'Cadastros',
       icon: 'fas fa-th',
       items: [
          {title: 'Coeficientes de Hoje', route: '/todayFactors'},
          {title: 'Tabelas de Coeficientes', route: '/bankChart'},
          // {title: 'Fluxo de Propostas', route: '/workflowConfig'},
          // {title: 'Configurações Discador', route: '/autoDialer'},
          // {title: 'Filas de Operadores', route: '/queues'},
          {title: 'Minha Empresa', route: '/company'},
          {title: 'Parceiros', route: '/partners'},
          {title: 'Filiais/Agentes', route: '/branches'},
          {title: 'Usuários', route: '/employees'},
          // {title: 'Convênios', route: '/covenants'}
       ]
    },
    {
      title: 'Links de Indicações',
      icon: 'fas fa-link',
      route: '/links'
    },
   {
      title: 'Afiliados',
      icon: 'fas fa-users',
      route: '/affiliates'
   },
   // {
   //    title: 'Notificações',
   //    icon: 'fa-bell',
   //    route: '/notifications'
   // },
   // {
   //    title: 'Gerenciar Notificações',
   //    icon: 'fa-cogs',
   //    route: '/manageNotifications'
   // },
 ];
 
 export default Menu;
 


// WEBPACK FOOTER //
// ./src/api/menu.js